import {
  computed, Ref, unref,
} from 'vue';
import Reservation from '@/model/Reservation';
import { guestCountsAtSlot } from '@/services/reservations-utils';
import { hourMinFromTimeText, slotFromMinutes } from '@/services/time-utils';

export type GuestCounts = { seated: number; incoming: number };

type GuestCountReservation = Pick<Reservation, 'partySize' | 'slotBegin' | 'slotEnd'>;
type MaybeRef<T> = T | Ref<T>;

export const reservationsFromByTime = (
  reservationsByTime: Map<string, Reservation[]>,
): GuestCountReservation[] => Array.from(reservationsByTime.values()).flat();

export const guestCountsByTimeMap = (
  reservations: GuestCountReservation[],
  reservationsByTime: Map<string, Reservation[]>,
): Map<string, GuestCounts> => {
  const map = new Map<string, GuestCounts>();

  reservationsByTime.forEach((_, timeText) => {
    const hm = hourMinFromTimeText(timeText);
    if (!hm) return;
    const slot = slotFromMinutes(hm.h * 60 + hm.m);
    map.set(timeText, guestCountsAtSlot(reservations, slot));
  });

  return map;
};

const useGuestCountsByTime = (reservationsByTime: MaybeRef<Map<string, Reservation[]>>) => {
  const guestCountsByTime = computed(() => {
    const byTime = unref(reservationsByTime);
    return guestCountsByTimeMap(reservationsFromByTime(byTime), byTime);
  });

  return { guestCountsByTime };
};

export default useGuestCountsByTime;
